import script from "./SubscriptionApplicantsDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionApplicantsDetailView.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionApplicantsDetailView.vue?vue&type=style&index=0&id=243fa888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-243fa888"]])

export default __exports__